export default __webpack_public_path__ + "static/media/ies_Siecled.ede1643d.png";